// import React, { useState } from "react";
// import { Controller } from "react-hook-form";
// import { Button } from "reactstrap";
// import Toaster from "../../../common/Toaster";

// const SaveRiskUpload = ({ control, name, label, onFileChange, allowedFileTypes, onDelete, uploadedFile, setIsoFile, setUplaodedFile, uploadClass, deleteClass, uploaMainWrap }) => {
//   const [inputKey, setInputKey] = useState(Date.now());

//   const handleDelete = () => {
//     void Toaster.error('File Deleted');
//     setIsoFile(null);
//     if (setUplaodedFile) {
//       setUplaodedFile(null);
//     }
//     if (onDelete) {
//       onDelete();
//     }
//   };

//   const isAcceptedFormat = (file) => {
//     return file && allowedFileTypes.includes(file?.type);
//   };

//   return (
//     <Controller
//       name={name}
//       control={control}
//       defaultValue={null}
//       render={({ field }) => (
//         <div className={`hl-upload-delete-wrap ${uploaMainWrap || ''}`}>
//           <input
//             key={inputKey}
//             type="file"
//             onChange={(e) => {
//               field.onChange(e.target.files[0]);
//               onFileChange(e, e.target.files[0]); // Change this line
//               setInputKey(Date.now());
//             }}
//             style={{ display: "none" }}
//             ref={(inputRef) => (field.ref = inputRef)}
//           />
//           <div className="hl-upload-btn-small">
//             <Button
//               className={`hl-upload-btn right ${uploadClass || ''}`}
//               variant="upload"
//               title="Upload"
//               onClick={() => {
//                 if (field.ref) {
//                   field.ref.click();
//                 }
//               }}
//             >
//               <div className="upload mr-0"></div>
//             </Button>
//           </div>
//           <div className="hl-download-btn hl-file-upload-title">
//             <div className="hl-file-title">
//               <span title={isAcceptedFormat(field.value) ? field.value?.name : ""}>
//                 {isAcceptedFormat(field.value) ? field.value?.name : ""}
//               </span>
//             </div>
//           </div>
//           {/* {uploadedFile && (
//             <div className={`hl-download-btn ${deleteClass || ''}`}>
//               <div className="hl-file-title">
//                 <span title={uploadedFile}>{uploadedFile} </span>
//               </div>
//             </div>
//           )} */}
//         </div>
//       )}
//     />
//   );
// };

// export default SaveRiskUpload;
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Button } from "reactstrap";
import Toaster from "../../../common/Toaster";

const SaveRiskUpload = ({ control, name, label, onFileChange, allowedFileTypes, onDelete, uploadedFile, setIsoFile, setUplaodedFile, uploadClass, deleteClass, uploaMainWrap, disabled }) => {
  const [inputKey, setInputKey] = useState(Date.now());
  const handleDelete = () => {
    void Toaster.error('File Deleted');
    setIsoFile(null);
    if (setUplaodedFile) {
      setUplaodedFile(null);
    }
    if (onDelete) {
      onDelete();
    }
  };

  const isAcceptedFormat = (file) => {
    return file && allowedFileTypes.includes(file?.type);
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <div className={`hl-upload-delete-wrap ${uploaMainWrap || ''}`}>
          <input
            key={inputKey}
            type="file"
            onChange={(e) => {
              field.onChange(e.target.files[0]);
              onFileChange(e, e.target.files[0]); // Change this line
              setInputKey(Date.now());
            }}
            style={{ display: "none" }}
            ref={(inputRef) => (field.ref = inputRef)}

          />
          <div className="hl-upload-btn-small">
            <Button
              className={`hl-upload-btn right ${uploadClass || ''}`}
              variant="upload"
              title="Upload"
              disabled={disabled} // Set disabled attribute here
              onClick={() => {
                if (field.ref) {
                  field.ref.click();
                }
              }}
            >
              <div className="upload mr-0"></div>
            </Button>
          </div>
          <div className="hl-download-btn hl-file-upload-title">
            <div className="hl-file-title">
              <span title={isAcceptedFormat(field.value) ? field.value?.name : ""}>
                {isAcceptedFormat(field.value) ? field.value?.name : ""}
              </span>
            </div>
          </div>
          {/* {uploadedFile && (
            <div className={`hl-download-btn ${deleteClass || ''}`}>
              <div className="hl-file-title">
                <span title={uploadedFile}>{uploadedFile} </span>
              </div>
            </div>
          )} */}
        </div>
      )}
    />
  );
};

export default SaveRiskUpload;

